import { Component, OnInit } from '@angular/core';
import { Cell } from '@app/layout/cell';
import { LayoutService } from '@app/layout/layout.service';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';
import * as g from 'src/app/globals';

type AttachmentKind = 'image' | 'file';

interface AttachmentItem {
  path: string;
  kind: AttachmentKind;
  name: string;
}

@Component({
  selector: 'app-cell-images',
  templateUrl: './cell-images.component.html',
  styleUrls: ['./cell-images.component.less'],
})
export class CellImagesComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService,
    private nzImageService: NzImageService,
  ) {
    super(layoutService, drawerService);
  }

  items: AttachmentItem[] = [];
  images: AttachmentItem[] = [];
  files: AttachmentItem[] = [];

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(): void {
    const paths = this.parseAttachmentsText(this.value || '');

    this.items = paths.map((p) => ({
      path: p,
      kind: this.isPreviewableImage(p) ? 'image' : 'file',
      name: this.extractName(p),
    }));

    this.images = this.items.filter((x) => x.kind === 'image');
    this.files = this.items.filter((x) => x.kind === 'file');
  }

  /** Click on image tile: preview gallery of all images */
  previewImageGallery(): void {
    if (this.images.length === 0) return;

    const nzImages: NzImage[] = this.images.map((x) => ({
      src: this.buildPreviewUrl(x.path),
      width: '50vw',
      height: 'auto',
      alt: x.name,
    }));

    this.nzImageService.preview(nzImages, { nzZoom: 1.5, nzRotate: 0 });
  }

  /** Click on file preview/download: same endpoint */
  previewOrDownloadFile(path: string): void {
    if (!path) return;

    const url = this.buildPreviewUrl(path);

    // More reliable than window.open (popup blockers)
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // ---------------- helpers ----------------

  private buildPreviewUrl(path: string): string {
    const safe = (path || '').split('#').join('_HASH_');
    return (
      g.apiBaseUrl +
      'media/previewfile?path=' +
      encodeURIComponent(safe) +
      '&' +
      g.getUrlSuffix()
    );
  }

  /** EXACT function you requested */
  private parseAttachmentsText(text: string): string[] {
    return (text || '')
      .split(/\r\n|\n|\r/)
      .map((s) => (s || '').trim())
      .filter((s) => s.length > 0);
  }

  private isPreviewableImage(path: string): boolean {
    const lower = (path || '').toLowerCase();
    return (
      lower.endsWith('.png') ||
      lower.endsWith('.jpg') ||
      lower.endsWith('.jpeg') ||
      lower.endsWith('.gif') ||
      lower.endsWith('.webp') ||
      lower.endsWith('.bmp')
    );
  }

  private extractName(path: string): string {
    try {
      const cleaned = path.split('?')[0];
      const parts = cleaned.split(/[\\/]/);
      return parts[parts.length - 1] || path;
    } catch {
      return path;
    }
  }
}
